import {
  Alert,
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
} from "@mui/material";
import useGlobalContext from "hooks/globalData";
import MediaLibraryItemUpdateForm from "pages/MediaLibraryPage/MediaLibraryItemUpdateForm";
import { useQuery } from "react-query";
import { MediaItemSource } from "services/KnowfullyAdminClient";
import { MediaType } from "utils/mediaUtils";
import { FormattedMessage as T } from "react-intl";

type HandoutUpdateDialogProps = {
  handoutId?: string;
  onUpdated: () => void;
  onClose: () => void;
};

export default function HandoutUpdateDialog({
  handoutId,
  onUpdated,
  onClose,
}: HandoutUpdateDialogProps) {
  const { mediaService } = useGlobalContext();
  const { isLoading, isFetched, data } = useQuery(
    ["media-item", handoutId],
    () =>
      mediaService.getItem(
        handoutId!,
        MediaItemSource.Handouts
      ),
    {
      enabled: !!handoutId,
    }
  );

  const handout = data?.data;

  return (
    <Dialog fullWidth maxWidth={"lg"} open={!!handoutId} onClose={onClose}>
      <DialogContent>
        {isLoading && (
          <Box textAlign="center">
            <CircularProgress />
          </Box>
        )}
        {isFetched && !handout && (
          <Alert severity="error">
            <T id="errorLoadingHandout" />
          </Alert>
        )}
        {!!handout && (
          <MediaLibraryItemUpdateForm
            alternativeTextRequired={false}
            customAlternativeTextLabel="displayText"
            source={MediaItemSource.Handouts}
            options={[MediaType.DOCUMENT, MediaType.IMAGE]}
            mediaItem={handout}
            onMediaLibraryItemUpdated={onUpdated}
            onCancel={onClose}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
